(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Set();
  const decorations = new Set();
  let latestRequest = 0;

  function remove(element) {
    element.remove();
    decorations.delete(element);
  }

  function stop() {
    latestRequest++;
    animations.forEach(animation => animation.cancel());
    animations.clear();
    decorations.forEach(remove);
  }

  function animate(element, frames, options, onFinish, onCleanup) {
    const animation = element.animate(frames, options);
    animations.add(animation);
    animation.finished.then(onFinish).catch(() => {}).finally(() => {
      animations.delete(animation);
      onCleanup?.();
    });
    return animation;
  }

  function canPlay(target, request) {
    return request === latestRequest && !preference.matches && !document.hidden &&
      target.isConnected && target.querySelector('.cart-count-bubble');
  }

  function celebrate(target) {
    // Feedback starts on confirmation, independently of the product image loading.
    animate(target, [
      {transform:'translateY(0) scale(1)',offset:0},
      {transform:'translateY(3px) scale(.88,.82)',offset:.12},
      {transform:'translateY(-12px) scale(1.2,1.14)',offset:.38},
      {transform:'translateY(2px) scale(1.07,.94)',offset:.62},
      {transform:'translateY(-3px) scale(.98,1.04)',offset:.8},
      {transform:'translateY(0) scale(1)',offset:1}
    ], {duration:820,easing:'cubic-bezier(.22,.68,.32,1)'});
    const icon = target.querySelector('.svg-wrapper');
    if (icon) animate(icon, [
      {transform:'rotate(0deg)'}, {transform:'rotate(-16deg)',offset:.24},
      {transform:'rotate(12deg)',offset:.5}, {transform:'rotate(-5deg)',offset:.72},
      {transform:'rotate(0deg)'}
    ], {duration:760,easing:'ease-in-out'});
    const badge = target.querySelector('.cart-count-bubble');
    if (badge) animate(badge, [
      {transform:'translateY(8px) scale(.35)',opacity:0},
      {transform:'translateY(-5px) scale(1.32)',opacity:1,offset:.5},
      {transform:'translateY(2px) scale(.92)',opacity:1,offset:.75},
      {transform:'translateY(0) scale(1)',opacity:1}
    ], {duration:620,delay:120,easing:'cubic-bezier(.2,.7,.3,1)',fill:'backwards'});

    const burst = document.createElement('span');
    burst.className = 'primo-cart-burst';
    burst.setAttribute('aria-hidden', 'true');
    decorations.add(burst);
    target.append(burst);
    const ring = document.createElement('span');
    ring.className = 'primo-cart-burst__ring';
    burst.append(ring);
    animate(ring, [
      {transform:'scale(.65)',opacity:0},
      {transform:'scale(1.08)',opacity:.8,offset:.22},
      {transform:'scale(1.95)',opacity:0}
    ], {duration:760,easing:'cubic-bezier(.16,1,.3,1)'});
    // A small, directional burst stays near the dock and never intercepts a tap.
    [-160,-125,-85,-45,-10,35].forEach((angle, index) => {
      const spark = document.createElement('span');
      spark.className = 'primo-cart-burst__spark';
      const radius = index % 2 ? 47 : 39;
      const x = Math.cos(angle * Math.PI / 180) * radius;
      const y = Math.sin(angle * Math.PI / 180) * radius;
      burst.append(spark);
      animate(spark, [
        {transform:'translate(0,0) scale(0) rotate(0deg)',opacity:0},
        {transform:`translate(${x * .55}px,${y * .55}px) scale(1.15) rotate(45deg)`,opacity:1,offset:.3},
        {transform:`translate(${x}px,${y}px) scale(0) rotate(120deg)`,opacity:0}
      ], {duration:650,delay:100 + index * 22,easing:'cubic-bezier(.16,1,.3,1)',fill:'both'});
    });
    animate(burst, [{opacity:1},{opacity:1}], {duration:940}, undefined, () => remove(burst));
  }

  window.addEventListener('pagehide', stop);
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
  preference.addEventListener('change', () => { if (preference.matches) stop(); });

  window.PrimoCartMotion = {
    async play() {
      stop();
      const request = latestRequest;
      if (preference.matches || document.hidden) return;
      const target = document.querySelector('.primo-nav__cart');
      if (!target || typeof target.animate !== 'function' || !canPlay(target, request)) return;
      const initialBounds = target.getBoundingClientRect();
      if (!initialBounds.width || initialBounds.bottom <= 0 || initialBounds.top >= innerHeight) return;
      celebrate(target);
      const card = document.createElement('div');
      card.className = 'primo-cart-flight';
      card.setAttribute('aria-hidden', 'true');
      const source = document.querySelector('#cart-notification-product img');
      if (source) {
        const image = source.cloneNode();
        image.alt = '';
        image.loading = 'eager';
        // Never display an empty card while the product image is decoding.
        try { await image.decode(); } catch { return; }
        if (!image.naturalWidth) return;
        card.append(image);
      } else {
        const icon = target.querySelector('svg');
        if (!icon) return;
        card.append(icon.cloneNode(true));
      }
      if (!canPlay(target, request)) return;
      decorations.add(card);
      document.body.append(card);
      // Use the resting position; the cart itself may already be mid-bounce.
      const x = initialBounds.left + initialBounds.width / 2 - innerWidth / 2;
      const y = initialBounds.top + initialBounds.height / 2 - innerHeight / 2;
      animate(card, [
        {transform:'translate(0,18px) scale(.45) rotate(-8deg)',opacity:0,offset:0},
        {transform:'translate(0,-24px) scale(.8) rotate(3deg)',opacity:1,offset:.18},
        {transform:`translate(${x * .35}px,${Math.min(y * .2, -85)}px) scale(.65) rotate(-10deg)`,opacity:1,offset:.5},
        {transform:`translate(${x}px,${y}px) scale(.08) rotate(8deg)`,opacity:0,offset:1}
      ], {duration:1050,easing:'cubic-bezier(.3,.65,.35,1)',fill:'forwards'}, () => {
        if (!canPlay(target, request)) return;
        animate(target, [
          {transform:'scale(1)'}, {transform:'scale(1.13,.88)',offset:.28},
          {transform:'scale(.97,1.06)',offset:.6}, {transform:'scale(1)'}
        ], {duration:360,easing:'ease-out'});
      }, () => remove(card));
    }
  };
})();
